module.exports = __webpack_public_path__ + "img/个人空间亮.907d2c73.png";